// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1XQOI","info":"PatientInfo_info__11p4Y"};